<template>
    <base-dialog :loading="loading" :value="dialog" :width="960" :fullscreen="isMobile" :title="$t('entrance.change_plan')"
        @input="val => { if (!val) hide() }" @close="hide">
        <select-plan v-if="dialog" with-coupon @change="plan = $event" @plan="showConfirm"
            @coupon="couponId = $event" />

        <kimsa-confirm ref="confirmModal" :title="$t('common.notice')" :content="confirmMessage" :loading="loading"
            :persistent="false" @confirm="save" :close-on-confirm="false" />
    </base-dialog>
</template>

<script>

import { mapActions } from "vuex"
import BaseDialog from "@/components/common/BaseDialog"
import SelectPlan from "@/components/coach/SelectPlan"
import KimsaConfirm from "@/components/common/KimsaConfirm"
import { subscribeCoachPlan } from "@/utils/Plans"

export default {
    name: "SelectPlanDialog",
    components: { BaseDialog, SelectPlan, KimsaConfirm },
    data() {
        return {
            dialog: false,
            loading: false,
            plan: null,
            couponId: null,
            confirmMessage: '',
        }
    },
    computed: {
        paymentMethodId(vm = this) {
            return vm.account?.stripeAccount?.paymentMethod?.id || null
        },
    },
    methods: {
        ...mapActions(['bindUserAccount']),
        show() {
            const vm = this
            vm.plan = null
            vm.couponId = null
            vm.dialog = true
        },
        hide() {
            const vm = this
            vm.dialog = false
        },
        showConfirm() {
            const vm = this
            if (!vm.plan?.isFree && !vm.paymentMethodId) return vm.toast(vm.$t('payment.no_has_credit_card'), 'error')

            vm.confirmMessage = vm.$t('coach.confirm_plan')
            const hasTrialDays = vm.account?.stripeAccount?.trialEnded === false || false
            if (hasTrialDays) vm.confirmMessage = `<b>${vm.$t('coach.yet_free_days')}</b> ${vm.confirmMessage}`
            vm.$refs.confirmModal.show()
        },
        async save() {
            const vm = this
            await vm.withLoading(async () => {
                const { status, messageKey, detail } = await subscribeCoachPlan({ plan: vm.plan, couponId: vm.couponId })
                if (vm.$refs.confirmModal) vm.$refs.confirmModal.hide()

                if (status === 'coupon-error') return vm.toast(vm.$t(messageKey), 'error')

                if (status === 'card-error') {
                    vm.toast(vm.$t(messageKey), 'error')
                    vm.hide()
                    return vm.pushRoute({ name: 'coach.credit-card', query: { deleted: 'true' } })
                }

                if (status === 'error') {
                    return vm.toast(`${vm.$t(messageKey)}${detail ? `: ${detail}` : ''}`, 'error')
                }

                await vm.bindUserAccount(vm.currentUser)
                vm.hide()
                vm.toast(vm.$t('common.changes_saved'))
            })
        },
    },
}
</script>
